export default {
  computed: {
    card: function () {
      if (this.$isIsef) {
        return 'NewProject'
      }
      if (this.displayType === 'registrationForm' && this.$route.name === 'adminJudge') {
        return 'JudgeApplication'
      } else if (this.displayType === 'judgeTeam' && this.$route.name === 'adminJudge') {
        return 'JudgeTeam'
      } else if (this.displayType === 'teamProject' && this.$route.name === 'adminJudge') {
        return 'JudgeTeamProject'
      }
      if (this.$isOhioScience) {
        if (this.isGroupProject) {
          return 'GroupProject'
        }
      }
      if (this.$isAjas) {
        return 'Ajas'
      }
      if (this.$isEngCom) {
        switch (this.contentType) {
          case 'game':
            return 'Game'
          case 'webinar':
            return 'Webinar'
          case 'whitepaper':
            return 'WhitePaper'
          case 'project':
            return 'Project'
          default:
            return 'Article'
        }
      }
      return 'Project'
    },
    contentType: function () {
      if (this.$isEngCom) {
        const isResource = this.project?.resource?.type?.name
        const isGame = this.project?.categories?.length > 0 && this.project?.categories?.every(cat => cat.slug === 'stem-games')
        const isTv = this.project?.categories?.filter(function (category) {
          return category.parentID === 266
        }).length > 0
        if (isGame) {
          return 'game'
        } else if (isTv) {
          return 'TV'
        } else if (isResource) {
          return isResource
        } else {
          return this.project?.type
        }
      } else if (this.project?.isTemplate) {
        return 'Template'
      } else if (this.$isYSC) {
        return 'JudgeTeam'
      } else {
        return this.project?.resource?.type?.name
      }
    },
    resourceTitle: function () {
      if (this.$isIsef) {
        return 'Booth'
      }
      if (this.$isEngCom) {
        switch (this.contentType) {
          case 'game':
            return 'STEM GAME'
          case 'TV':
            return 'TV'
          case 'project':
            return 'Article'
          case 'SPONSORED':
            return 'Sponsored'
          case 'webinar':
            return 'Webinar'
          case 'white paper':
            return 'Whitepaper'
          case 'app':
            return 'App'
          case 'ebook':
            return 'Ebook'
          case 'research report':
            return 'Research Report'
          case 'calculators':
            return 'catalog'
          case 'brief':
            return 'Brief'
          case 'case study':
            return 'Case Study'
          case 'magazine':
            return 'Magazine'
          case 'application note':
            return 'Application note'
          case 'contest':
            return 'Contest'
          case 'sample':
            return 'Sample'
          case 'education':
            return 'Education'
          case 'handout':
            return 'Handout'
          case 'program guide':
            return 'Program Guide'
          case 'free version':
            return 'Free Version'
          case 'guide':
            return 'Guide'
          case 'beta Test':
            return 'Beta Test'
          case 'datasheet':
            return 'DataSheet'
          case 'software':
            return 'Software'
          case 'resource':
            return 'Resource'
          default:
            return 'Article'
        }
      }
      return 'Project'
    }
  }
}
